import React, { useState, useRef } from 'react';
import { BsFillPlayFill, BsPauseFill } from 'react-icons/bs';
import { meal } from '../../constants';
import './Intro.css';



const Intro = () => {

  const [playVideo, setPlayVideo] = useState(false);
  const vidRef = useRef(); 

  const handleVideo = () => {
    setPlayVideo(!playVideo);
    if(playVideo)
    {
      vidRef.current.pause();
    }
    else
    {
      vidRef.current.play();
    }
  }

  return (

      <div className='app__video' onClick={handleVideo}>
        <video 
          src={meal} 
          ref={vidRef}
          type="video/mp4"
          loop
          controls={false}
          muted
        />
        <div className="video-container flex__center">
          <div className="video-circle flex__center" onClick={handleVideo}>
              {playVideo ? (
                <BsPauseFill color="#fff" fontSize={30} />
              ) : (
                <BsFillPlayFill color="#fff" fontSize={30} />
              )}
          </div>
        </div>
      </div>

  )


};

export default Intro;
